/**
 * Constants for Curriculum Tree Search
 */

/** Minimum characters to trigger search */
export const MIN_SEARCH_CHARS = 3

/** Debounce delay for search input (ms) */
export const SEARCH_DEBOUNCE_MS = 400

/** Maximum results to display */
export const MAX_SEARCH_RESULTS = 50

/** Cache key prefix for sessionStorage */
export const CACHE_KEY_PREFIX = 'curriculum_tree_'

/** Cache TTL in milliseconds (24 hours) */
export const CACHE_TTL_MS = 24 * 60 * 60 * 1000

/** Relevance scoring weights */
export const RELEVANCE_SCORES = {
  /** Exact code match */
  CODE_EXACT: 100,
  /** Code starts with term */
  CODE_STARTS: 80,
  /** Code contains term */
  CODE_CONTAINS: 60,
  /** Name starts with term */
  NAME_STARTS: 70,
  /** Name contains term */
  NAME_CONTAINS: 40,
  /** LV2 ancestor match bonus */
  LV2_MATCH_BONUS: 30,
  /** LV3 ancestor match bonus */
  LV3_MATCH_BONUS: 20,
} as const
